var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticStyle:{"font-size":"100px","text-align":"center"}},[_vm._v(" 500 ")])
}
var staticRenderFns = []

export { render, staticRenderFns }